
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"56","height":"56"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28 55.989A28 28 0 018.2 8.2a28 28 0 1139.6 39.59A27.842 27.842 0 0128 55.989zm-.79-17.059a4.346 4.346 0 103.082 7.4 4.279 4.279 0 001.264-3.056 4.351 4.351 0 00-4.351-4.343zm.581-24.505c3.191 0 5.1 1.7 5.1 4.559 0 2.478-2.092 4.091-4.306 5.8-2.447 1.887-4.978 3.838-4.978 7.15a3.369 3.369 0 003.395 3.55c2.5 0 3.007-1.339 3.542-2.757a7.9 7.9 0 01.8-1.7 12.305 12.305 0 012.843-2.412c2.851-2.03 6.755-4.809 6.755-9.628 0-7.829-7.258-10.607-13.473-10.607-6.495 0-12.409 4.677-12.409 9.812a3.181 3.181 0 003.44 3.233c2.4 0 3.109-1.525 3.86-3.14.887-1.897 1.8-3.86 5.427-3.86z","fill":"#222"}})])
          )
        }
      }
    